// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"afd9b0a4","112":"31837da2","152":"2a327d14","348":"f5f2d2a9","368":"6796a412","380":"13461f10","392":"3816be5d","400":"966df652","608":"80319015","700":"72b90f61","716":"62c3f44b","736":"7c4f809e","744":"671b7105","824":"266dfa36","992":"f92416d0"}[chunkId] + ".chunk.js";
};